import { render, staticRenderFns } from "./ImageUiComponent.vue?vue&type=template&id=3a2db734&"
import script from "./ImageUiComponent.vue?vue&type=script&lang=ts&"
export * from "./ImageUiComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports